import React, { useRef, useEffect, useState } from "react";

import AuthService from "../../services/auth.service";
import { useNavigate } from "react-router-dom";
//--- CONTEXT API -----------
import { useStore, useDispatch } from "store/StoreProvider";

const Sidebar1 =(props)=>{
  const navigate = useNavigate();
  //---------------- CONTEXT API ------------------
  const store = useStore();
  const {user, products} = store;


  //-----------------------------------
  const logout=(e)=>{
    e.preventDefault();
    
    //console.log("aqui estoy");
    AuthService.logout();
    navigate("/login");
    //let history = useHistory();
    //history.push("/login");
  }

  const miClase = props.onShow? 'active':'';
  return (
    <nav id="sidebar" className={`mCustomScrollbar _mCS_1 mCS-autoHide ${miClase} `}
          style={{overflow: 'visible'}}>

      <div id="mCSB_1" className="mCustomScrollBox mCS-minimal mCSB_vertical mCSB_outside"
        style={{ maxHeight: 'none'}} tabindex="0">
        <div id="mCSB_1_container" className="mCSB_container mCS_y_hidden mCS_no_scrollbar_y"
          style={{position:'relative', top:0, left:0, }} dir="ltr">

          <div className="sidebar-header">
            <h4>{user.username } </h4>
          </div>

          <ul className="list-unstyled components">
            <span className="text-center">

            </span>
          </ul>

          <ul className="list-unstyled CTAs">
            <li>
              <button className="btn btn-info" onClick={logout} >Cerrar session</button>
            </li>
          </ul>
        </div>
      </div>

      <div id="mCSB_1_scrollbar_vertical" 
          className="mCSB_scrollTools mCSB_1_scrollbar mCS-minimal mCSB_scrollTools_vertical" 
          style={{ display: 'none'}}>
          <div className="mCSB_draggerContainer">
            <div  id="mCSB_1_dragger_vertical" className="mCSB_dragger" 
                  style={{ position: 'absolute',  minHeight: '49.9901px', height: 0,  top: 0 }}>
                  <div className="mCSB_dragger_bar" style={{ lineHeight: '49px' }}>
                  </div>
            </div>

            <div className="mCSB_draggerRail">
            </div>
          </div>
      </div>
     
      
    </nav >
  )
}

export default Sidebar1
